import { render, staticRenderFns } from "./PlayerAndTeamsSelector.vue?vue&type=template&id=5966492c&scoped=true&"
import script from "./PlayerAndTeamsSelector.vue?vue&type=script&lang=ts&"
export * from "./PlayerAndTeamsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerAndTeamsSelector.vue?vue&type=style&index=0&id=5966492c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966492c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
